import { FvButton, FvLinkButton } from '@fv/client-components'

import { DividedContent } from '@/components/DividedContent'
import { routes } from '@/routes'

import { NotificationDocCenterDetails } from './details/NotificationDocCenterDetails'
import { NotificationLoadDetails } from './details/NotificationLoadDetails'
import {
  useArchiveNotification,
  useUpdateNotificationStatus,
} from './mutations'
import { notificationRegistry } from './NotificationRegistry'
import { useNotification } from './queries'

interface NotificationDetailsPanelProps {
  notificationId: string | null
  onArchive: () => void
}

export const NotificationDetailsPanel = ({
  notificationId,
  onArchive,
}: NotificationDetailsPanelProps) => {
  const notificationQuery = useNotification(notificationId)
  const notification = notificationQuery.data
  const updatePin = useUpdateNotificationStatus(notification)
  const handlePinClick = async () => {
    await updatePin.mutateAsync({ pinned: !notification?.pinned })
  }
  const archive = useArchiveNotification()
  const handleArchive = async () => {
    await archive.mutateAsync(notification?._id)
    onArchive()
  }
  if (!notification) {
    return (
      <div className="border-l-2 border-fv-orange -ml-[2px] flex flex-col overflow-hidden">
        <div className="flex-1 overflow-auto p-6">
          <p className="text-fv-gray-dark">
            Select a notification to view details
          </p>
        </div>
      </div>
    )
  }

  const hasLoadDetails = notification.loadId
  const DetailsComponent =
    notificationRegistry[notification.notificationType]?.component

  return (
    <div className="border-l-2 border-fv-orange -ml-[2px] flex flex-col overflow-hidden">
      <div className="flex-1 overflow-auto p-6">
        <NotificationLoadDetails notification={notification} />
        <NotificationDocCenterDetails notification={notification} />
        {DetailsComponent && <DetailsComponent notification={notification} />}
      </div>
      <DividedContent
        theme="blue"
        className="mt-auto  bg-fv-blue-50 px-6 py-4 border-t border-fv-blue-200"
      >
        {!notification.archivedDate && (
          <FvButton
            icon="thumbtack"
            className="first:pl-0"
            loading={updatePin.isPending}
            onClick={handlePinClick}
          >
            {notification.pinned ? 'Unpin' : 'Pin'}
          </FvButton>
        )}
        {hasLoadDetails && (
          <FvLinkButton
            icon="arrow-to-right"
            to={routes.details(notification.loadId)}
          >
            View shipment
          </FvLinkButton>
        )}
        {!notification.archivedDate && (
          <FvButton
            icon="archive"
            onClick={handleArchive}
            loading={archive.isPending}
          >
            Archive {!notification.userId ? 'for everyone' : ''}
          </FvButton>
        )}
      </DividedContent>
    </div>
  )
}
